import React from 'react';
import PropTypes from 'prop-types';
import OutsourceTreeDetail from "./OutsourceTreeDetail";

export default class OutsourceTreeItemDetail extends React.Component {

  renderChildren(children){
    return children.map((contract, i) => {
      return(
        <OutsourceTreeItemDetail key={i} contract={contract}/>
      );
    });
  }

  render() {
    const { contract } = this.props;
    if (!contract){
      return null;
    }
    return (
      <li>
        <div className="row">
          <div className="col-xs-1">
            <span className={OutsourceTreeDetail.renderLabelClass(contract.company.level)}>{contract.company.level}</span>
          </div>
          <div className="col-xs-10">
            <p>{contract.company.name}</p>
          </div>
        </div>
        <ul>
          {this.renderChildren(contract.children)}
        </ul>
      </li>
    );
  }

}


OutsourceTreeItemDetail.propTypes = {
  contract: PropTypes.any
};

OutsourceTreeItemDetail.defaultProps = {
};



// WEBPACK FOOTER //
// ./src/app/works/components/OutsourceTreeItemDetail.js